
// Libraries
var React = require('react');

// Components
var AlgoliaSearchModule = require('AlgoliaSearch/AlgoliaSearchModule');

// Styles
require('./SearchOverlay.scss');

class SearchOverlay extends React.Component {
	handleEscKey = (event) => {
		if (event.key === 'Escape') {
			this.props.toggleOverlay();
		}
	}

	render() {
		return (
			<div className={"SearchOverlay" + (this.props.isOverlayOpen ? " is-open" : "")} onKeyDown={this.handleEscKey}>
				<AlgoliaSearchModule mode="header" closeOverlay={this.props.toggleOverlay} />
			</div>
		)
	}

	componentDidUpdate() {

		if (typeof window === "undefined") return;

		const searchInput = document.querySelector('.SearchOverlay [data-algolia-search-input] input');
		if (searchInput) searchInput.focus();

	}
}

module.exports = SearchOverlay;



// WEBPACK FOOTER //
// ./src/components/Search/SearchDesktop/SearchOverlay.js